
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("i81rh", function(module, exports) {

$parcel$export(module.exports, "UpgradeEditionButton", () => $a2ec28d916b8f587$export$2f4bd8d23e81b246);
$parcel$export(module.exports, "LearnMoreButton", () => $a2ec28d916b8f587$export$176492db868efc7f);
$parcel$export(module.exports, "ChangeEditionInlineDialogLoader", () => (parcelRequire("b27bJ")).ChangeEditionInlineDialogLoader);
$parcel$export(module.exports, "ChangeEditionInlineDialogPaintLoader", () => (parcelRequire("b27bJ")).ChangeEditionInlineDialogPaintLoader);
$parcel$export(module.exports, "ChangeEditionLegacyCoordinator", () => (parcelRequire("lyZNZ")).ChangeEditionLegacyCoordinator);
$parcel$export(module.exports, "withIsSiteAdmin", () => (parcelRequire("f7Bnv")).withIsSiteAdmin);
$parcel$export(module.exports, "SECTION_MESSAGE_APPEARANCE_TYPES", () => (parcelRequire("gsZdA")).SECTION_MESSAGE_APPEARANCE_TYPES);

var $jmjWc = parcelRequire("jmjWc");

var $b27bJ = parcelRequire("b27bJ");

var $lyZNZ = parcelRequire("lyZNZ");

var $f7Bnv = parcelRequire("f7Bnv");

var $gsZdA = parcelRequire("gsZdA");

const $a2ec28d916b8f587$export$2f4bd8d23e81b246 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VTzWO",
    name: "UpgradeEditionButton",
    loader: async ()=>(await Promise.resolve((parcelRequire("ki6F7")))).UpgradeEditionButton
});

const $a2ec28d916b8f587$export$176492db868efc7f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "PEHOP",
    name: "LearnMoreButton",
    loader: async ()=>(await Promise.resolve((parcelRequire("iJ9aA")))).LearnMoreButton
});

});
parcelRegister("b27bJ", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionInlineDialogLoader", () => $306758770d5ee79f$export$4556cd06b2dec862);
$parcel$export(module.exports, "ChangeEditionInlineDialogPaintLoader", () => $306758770d5ee79f$export$5902d4a19951b5c3);

var $jmjWc = parcelRequire("jmjWc");

const $306758770d5ee79f$export$4556cd06b2dec862 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PlyJG",
    name: "ChangeEditionInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("liL1j"))).ChangeEditionInlineDialog
});

const $306758770d5ee79f$export$5902d4a19951b5c3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4GH4a",
    name: "ChangeEditionInlineDialogPaintLoader",
    loader: async ()=>(await (parcelRequire("liL1j"))).ChangeEditionInlineDialog
});

});
parcelRegister("liL1j", function(module, exports) {

let $f81fc0a1137a026d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f81fc0a1137a026d$var$load("6vzdH"),
    $f81fc0a1137a026d$var$load("9V9Fn"),
    $f81fc0a1137a026d$var$load("1zoBu")
]).then(()=>parcelRequire('4QNfT'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});




parcelRegister("lyZNZ", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionLegacyCoordinator", () => $f60f9bb0af41c642$export$ddc928ad192d2b94);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $bQm3c = parcelRequire("bQm3c");

var $jFZ8R = parcelRequire("jFZ8R");

var $8zd8e = parcelRequire("8zd8e");
const $f60f9bb0af41c642$export$ddc928ad192d2b94 = ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zd8e.ChangeEditionSectionMessageLegacyCoordinator), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jFZ8R.ChangeEditionPageRestrictionsLegacyCoordinator), null))) : null;

});
parcelRegister("jFZ8R", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionPageRestrictionsLegacyCoordinator", () => $e5314625536bb69f$export$5b44234181f42094);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $b1HmN = parcelRequire("b1HmN");

var $kOTdT = parcelRequire("kOTdT");
const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $2nPZH.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $2nPZH.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Mutation), {
                    mutation: (0, $kOTdT.ClearRestrictionsForFreeMutation),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $js7oX.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);

});
parcelRegister("kOTdT", function(module, exports) {

$parcel$export(module.exports, "ClearRestrictionsForFreeMutation", () => $13bb14eac5ea00fc$export$bae28e68d0aa638c);

var $d2LG0 = parcelRequire("d2LG0");
const $13bb14eac5ea00fc$export$bae28e68d0aa638c = (0, $d2LG0.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;

});


parcelRegister("8zd8e", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionSectionMessageLegacyCoordinator", () => $63cbc74b40cb8d33$export$b9f1eac8c818cdb0);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $dio2n = parcelRequire("dio2n");

var $5EeGi = parcelRequire("5EeGi");
const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $gwFzn.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $5EeGi.ChangeEditionSectionMessageSpaceContent),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $dio2n.ChangeEditionSectionMessageAuditLogs)
        };
    }
}

});
parcelRegister("dio2n", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionSectionMessageAuditLogs", () => $4c2daaa3bc0c282d$export$cb2ba78fe55aff74);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1ytiN = parcelRequire("1ytiN");

var $4WmbV = parcelRequire("4WmbV");
const $4c2daaa3bc0c282d$var$i18n = (0, $2nPZH.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};

});

parcelRegister("5EeGi", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionSectionMessageSpaceContent", () => $ee74963fbde2c4ed$export$51350d82d36f7e43);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $f7Bnv = parcelRequire("f7Bnv");

var $4WmbV = parcelRequire("4WmbV");
const $ee74963fbde2c4ed$var$i18n = (0, $2nPZH.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $dBxQj.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);

});




parcelRegister("hAnPj", function(module, exports) {

$parcel$export(module.exports, "LazyRestrictionsDialogMountPoint", () => $bb619eb96b539cb1$export$8c358bcfa2c0ec3f);
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => (parcelRequire("lQDcS")).RestrictionsDialogMenuPropsProvider);

var $jmjWc = parcelRequire("jmjWc");

var $SAFLR = parcelRequire("SAFLR");

var $lEXFh = parcelRequire("lEXFh");

var $lQDcS = parcelRequire("lQDcS");

const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("4aCpe"))).RestrictionsDialogMountPoint
});

});
parcelRegister("SAFLR", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => $84211cd137cf57b0$export$e8086e85d5f7d830);

var $gwFzn = parcelRequire("gwFzn");

var $ln0hx = parcelRequire("ln0hx");
var $irVI7 = parcelRequire("irVI7");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $lEXFh = parcelRequire("lEXFh");
const $84211cd137cf57b0$export$e8086e85d5f7d830 = (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};

});
parcelRegister("lEXFh", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogTrigger", () => $0b24ce56d1d6b617$export$4a978df01c3bf89e);
$parcel$export(module.exports, "startRestrictionsDialogExperience", () => $0b24ce56d1d6b617$export$59974e42a4613c7);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7d2Nc = parcelRequire("7d2Nc");
parcelRequire("i81rh");
var $b27bJ = parcelRequire("b27bJ");

var $euL71 = parcelRequire("euL71");

var $5u6LZ = parcelRequire("5u6LZ");

var $8RR7m = parcelRequire("8RR7m");

var $9wGTI = parcelRequire("9wGTI");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");

var $jLw6A = parcelRequire("jLw6A");
var $ckmNl = parcelRequire("ckmNl");

var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $bVAxT = parcelRequire("bVAxT");

var $14SPd = parcelRequire("14SPd");

var $cSVAY = parcelRequire("cSVAY");

var $eE3dj = parcelRequire("eE3dj");

var $fkOJz = parcelRequire("fkOJz");
const $0b24ce56d1d6b617$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    verticalAlign: 'top'
});
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $gwFzn.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleGrantAccessActionClicked = ()=>{
        setState((state)=>({
                ...state,
                grantAccessClicked: true
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state)=>({
                ...state,
                showFreeRestrictionDialog: true
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const onFreeDialogClosed = ()=>{
        setState((state)=>({
                ...state,
                showFreeRestrictionDialog: false
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const renderFreeEditionDialog = (dialogStateContainer, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions })=>{
            if (!restrictions && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions?.hasRestrictions || restrictions?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions?.hasInheritedRestrictions && !restrictions?.hasRestrictions);
            const immediateParentPageIndex = (restrictions?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0;
            // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        shouldHideSpinner: state.showFreeRestrictionDialog,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        shouldHideSpinner: true,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer)();
                    setState((state)=>({
                            ...state,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                }
                // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
                    resetDialogState: ()=>dialogStateContainer.initState(),
                    onClick: makeHandleOpen(dialogStateContainer),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    shouldHideSpinner: true,
                    onClick: makeHandleOpen(dialogStateContainer),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                shouldHideSpinner: state.showFreeRestrictionDialog,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                shouldHideSpinner: true,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        if (triggeredFrom && triggeredFrom === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled,
            shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
            onClick: makeHandleOpen(dialogStateContainer),
            resetDialogState: ()=>dialogStateContainer.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled,
            shouldHideSpinner: true,
            onClick: makeHandleOpen(dialogStateContainer),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom
        });
    };
    //  accessType=view&grantAccess=true&username=rwu&userFullName=Robin+Wu
    const renderGrantAccessDialogAndButton = (getQueryParams, dialogStateContainer, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        const queryParams = getQueryParams();
        const shouldSSRGrantAccessRestrictions = triggeredFrom === 'fromView';
        if (shouldShowDialog && !state.grantAccessClicked) {
            const accountId = (0, $c3Qwv.getSingleParam)(queryParams, 'accountId');
            // TODO(brizvash): non-gdpr params, remove when GDPR is on
            // "username" in the URL is actually the accountId in legacy circumstances
            // which we will use to fetch username from backend
            const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, 'username') || '';
            // render grant access requested user
            // preloading the queries means that isOpen wil always be true in SSR.
            // here, we set isOpen to false during SSR so the modal doesn't open on SSR (since
            // there is no handling for the inner modal clicks)
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5u6LZ.GrantAccessDialogLoader), {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isOpen: true,
                contentId: contentId,
                onActionClick: handleGrantAccessActionClicked,
                accessType: (0, $c3Qwv.getSingleParam)(queryParams, 'accessType') === 'edit' ? 'edit' : 'view',
                // When accountId is not present, username will have the Id
                accountId: accountId || legacyUsername,
                shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
            }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
                resetDialogState: ()=>dialogStateContainer.initState(),
                onClick: makeHandleOpen(dialogStateContainer),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                shouldHideSpinner: true,
                onClick: makeHandleOpen(dialogStateContainer),
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom
            }));
        }
        return renderRestrictionsButton(dialogStateContainer);
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, renderRestrictionsButton(dialogStateContainer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $0b24ce56d1d6b617$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams })=>{
            const { accountId: accountId, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
            const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)('confluence_frontend_grant_access_flag') ? renderGrantAccessFlagAndButton(dialogStateContainer) : renderGrantAccessDialogAndButton(getQueryParams, dialogStateContainer, shouldShowGrantAccessDialog);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}

});


parcelRegister("lQDcS", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => $3b0d5969bb769929$export$b0eaba4fdbbe6e8b);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");

var $bVAxT = parcelRequire("bVAxT");

var $bQm3c = parcelRequire("bQm3c");

var $lEXFh = parcelRequire("lEXFh");
const $3b0d5969bb769929$var$label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
    id: "restrictions.dialog.link.text",
    defaultMessage: "Restrictions"
});
function $3b0d5969bb769929$export$b0eaba4fdbbe6e8b({ children: children, contentId: contentId }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Note: this is used for balance A/B testing user cohorts, it will be replaced with real feature flag later.
    return children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>children({
            id: 'bm-restrictions-link',
            label: $3b0d5969bb769929$var$label,
            onClick () {
                (0, $lEXFh.startRestrictionsDialogExperience)({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: 'restrictionsDialogLink',
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    triggeredFrom: 'actionsMenu',
                    contentId: contentId
                });
            }
        })) : null;
}

});

parcelRegister("4aCpe", function(module, exports) {

let $3095e3325f278d8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3095e3325f278d8c$var$load("7tpaU"),
    $3095e3325f278d8c$var$load("joJy8"),
    $3095e3325f278d8c$var$load("aHE9G"),
    $3095e3325f278d8c$var$load("fno6o")
]).then(()=>parcelRequire('ca7si'));

});


var $ec574287659da672$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"l4Ek9\",\"ShareButton.2e163b02.js\",\"1zoBu\",\"ChangeEditionInlineDialog.b147faf6.js\",\"9V9Fn\",\"ChangeEditionInlineDialog.c739d57c.js\",\"6vzdH\",\"ErrorComponent.f5b779fb.js\",\"fno6o\",\"RestrictionsDialogMountPoint.8b4ba2d9.js\",\"2VACG\",\"RestrictionsUpsellDialog.ce12ef25.js\",\"aHE9G\",\"vendors~editor_atlaskit.588a3242.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.8e54b7e2.js\",\"7tpaU\",\"RestrictionsDialogMountPoint.48dd0675.js\",\"inQqk\",\"RestrictionsDialog.5adaa79c.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"c6MKV\",\"stable_vendors.93436621.js\",\"ffEVr\",\"vendors~editor_icon.f07e1d38.js\",\"6qah4\",\"atl.37770927.js\",\"aZinD\",\"vendors.6874964d.js\",\"8DoxJ\",\"modal.2efbd67a.js\",\"7sseo\",\"modal.d25dccfb.js\",\"hKqxh\",\"modal.runtime.7aa8e098.js\",\"cOK8C\",\"FullPageEditorComponent.64b54921.js\",\"6nLV7\",\"NativeCollabComponent.340e7d79.js\",\"ipK41\",\"NativeCollabComponent.f247eff8.js\",\"3bo82\",\"ShareButton.410bf0ee.js\",\"7pZ0V\",\"ShareButton.15af10fe.js\",\"zogKQ\",\"ReadTime.d2cea5e7.js\",\"8yyrA\",\"UpFlow.0f005a22.js\",\"1TOYq\",\"CoreInvites.0dca447d.js\",\"5JvKa\",\"CoreInvites.329b1046.js\",\"jkoeR\",\"RendererContentStateWithSpotlight.b53b11af.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.06f73c08.js\",\"17Bgt\",\"PageLabelsAutomationDiscovery.f257e14f.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.8e54b7e2.js\",\"hKqxh\",\"modal.runtime.7aa8e098.js\",\"f7WA2\",\"SlackDiscoveryDialog.712a9aa7.js\",\"eRzO9\",\"BulkChangePageOwnerDialog.08964cc4.js\",\"1rMtp\",\"PagePublishAutomationDiscoveryDialog.3c9cfac6.js\",\"6qiXX\",\"SpaceAdminConfig.902468e4.js\",\"8rEwj\",\"PagePublishAutomationDiscoveryDialog.d5bb9f9f.js\",\"gkMTK\",\"PagePublishAutomationDiscoveryDialog.b260b449.js\",\"iAaum\",\"es.ed6b705d.js\",\"jdEwy\",\"JiraLinkAutomationDiscoveryDialog.32f1829b.js\",\"696ho\",\"WhiteBoardPublishDiscoveryDialog.e07949be.js\",\"1NKZf\",\"AutomationDiscoveryHoverPageTitleMessage.9dad65d3.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.6154d0bf.js\",\"11AeH\",\"AutomationDiscoveryHeader.6db01409.svg\",\"hdBGO\",\"ShareButton.7a50d8ae.js\",\"jOlrD\",\"LazyShareForm.8742a2d6.js\",\"2jdQ1\",\"LazyShareFormNext.c6193617.js\",\"a0ogJ\",\"LazyShareFormNext.2acccb85.js\",\"dIuhJ\",\"link-filled.19c799b9.js\",\"8M2wy\",\"LazyShareFormNext.f404e1ec.js\",\"k9kY4\",\"share.a9a91416.js\",\"lfEn7\",\"ShareButton.58ba6f5a.js\",\"fwbht\",\"ShareButton.0a753bfb.js\",\"lAtSO\",\"ShareButton.34756a91.js\",\"ftJgg\",\"ShareButton.f5289ded.js\",\"fNL1b\",\"ReadTimePopup.00d416e2.js\",\"mKoWX\",\"nativeEditorComponentsPreloader.9b988c7a.js\",\"1ISAt\",\"nativeEditorComponentsPreloader.runtime.4fc55fcd.js\",\"1ISAt\",\"nativeEditorComponentsPreloader.runtime.4fc55fcd.js\",\"ew1CD\",\"ShareButtonLite.a259a0bd.js\",\"cdEjw\",\"NativeCollabComponent.377a0f0f.js\",\"KS1sL\",\"ContentTypesHeader.6f856048.js\",\"7XPb0\",\"Whiteboard.8508f2af.js\",\"gGI57\",\"Page.43016ef1.js\",\"i9ToQ\",\"ViewPage.e8b7cba9.js\",\"lPCqB\",\"FullPageEditorComponent.b1011b8a.js\",\"34R0T\",\"AgentPresence.9d484337.js\",\"kPKOV\",\"AgentProfileCard.6e0835d0.js\",\"c9Qqc\",\"auto-dev.998d58bd.js\",\"1TK6P\",\"auto-fix.07790e95.js\",\"grvAy\",\"auto-review.eb6c556a.js\",\"23K0q\",\"backlog-buddy.77803ebe.js\",\"3kQkj\",\"comms-crafter.37031eba.js\",\"6OXgE\",\"culture.46528ca4.js\",\"cbucA\",\"customer-insight.b71811cb.js\",\"bVhr1\",\"decision-director.cdf61897.js\",\"kE0QC\",\"feature-flag-avatar.c60bd9d5.js\",\"eVFXf\",\"generic-avatar.0faf04ac.js\",\"9FhBz\",\"hire-writer.9e73f27f.js\",\"6zB8z\",\"marketing-message-maestro.d95d5d6b.js\",\"eENGY\",\"my-user-manual.277d400f.js\",\"hmlb0\",\"okr-oracle.501b2473.js\",\"2NGxc\",\"ops-agent.6b999ec1.js\",\"bPgcq\",\"pitch-perfector.33d8fc56.js\",\"31b1q\",\"product-requirement.2b164fec.js\",\"8Lh9U\",\"release-notes.c909e5c4.js\",\"6ZzYJ\",\"research-scout.6dccd2a5.js\",\"410SS\",\"social-media-scribe.404e9147.js\",\"z3s9q\",\"team-connection.62db7c27.js\",\"9gqcE\",\"workflow-builder.48a79198.js\",\"2u53D\",\"FullPageEditorComponent.55cf41dc.js\",\"2KJHS\",\"esm.90a6c55b.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"eb06U\",\"AgentProfileCard.16f77680.js\",\"9gJO7\",\"modal.2bc29086.js\",\"6cVEd\",\"fire-event.6ce5cb1f.js\",\"5YJ6r\",\"ReadTimePopup.5048d579.js\",\"bZxqd\",\"modal.aa7aff6c.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.1b7a934b.js\",\"1S9KM\",\"lock-locked--lock-circle.11c51b01.js\",\"bL008\",\"lock-circle.fdb473df.js\",\"gIMXh\",\"FollowCursorOnboardingHeader.4193dac1.svg\",\"3u6ne\",\"WhiteboardTeammateLight.c29609b9.svg\",\"1TWTl\",\"WhiteboardTeammateDark.718ee45a.svg\",\"hkGfe\",\"FullPageEditorComponent.30b0e826.js\",\"9ZnVA\",\"FullPageEditorComponent.1fa65840.js\",\"b03Lm\",\"FullPageEditorComponent.runtime.f1bfd76f.js\",\"eFpF6\",\"FullPageEditorComponent.d86e482a.js\",\"a4y7a\",\"FullPageEditorComponent.704f889b.js\",\"5aY5g\",\"ReadTimePopup.b9f2f457.js\",\"aGZFn\",\"ReadTimePopup.16f36c14.js\",\"kjZZD\",\"vendors~editor_icon-object.9a945e69.js\",\"ffEVr\",\"vendors~editor_icon.f07e1d38.js\",\"5TfXH\",\"FullPageEditorComponent.544cf40d.js\",\"feuOx\",\"FullPageEditorComponent.90f69f17.js\",\"g9CVe\",\"mention.28df720c.js\",\"dTsOE\",\"modal.dc2d010b.js\",\"cyGuT\",\"feedback-collector.75f1cc85.js\",\"aHE9G\",\"vendors~editor_atlaskit.588a3242.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.8e54b7e2.js\",\"aZinD\",\"vendors.6874964d.js\",\"c6MKV\",\"stable_vendors.93436621.js\",\"iAaum\",\"es.ed6b705d.js\",\"77Ha0\",\"GlobalFeedbackCollector.8ff5a87d.js\",\"931GG\",\"FullPageEditorComponent.23cf333d.js\",\"i5Fj1\",\"data-classification.21d326e8.js\",\"jnk96\",\"DataClassification.fbd16edc.js\",\"aZ3wY\",\"DataClassification.806500c7.js\",\"3UR1K\",\"DataClassification.5839c591.js\",\"5Smk7\",\"HelpPanel.75a07e54.js\",\"3b99S\",\"EditorContentClassificationTag.b1e33683.js\",\"c6gxD\",\"EditorContentClassificationTag.3959b120.js\",\"1zPhe\",\"EditorDataClassification.d164af03.js\",\"avzJW\",\"EditorDataClassificationComponent.a0d19f8b.js\",\"4Oj5y\",\"ContentTypeClassification.6ec5d514.js\",\"iJsKa\",\"ClassificationReadViewPopup.c16e8f90.js\",\"kVNpE\",\"ClassificationReadViewPopup.39a34326.js\",\"cEDfx\",\"DataClassificationHoverButton.229e6e5c.js\",\"9wTW2\",\"EditorClassificationTagWrapper.f24b8d90.js\",\"5odbj\",\"ClassificationTagButtonError.1b9558b9.js\",\"4Qstt\",\"ClassificationEditModal.be913cbd.js\",\"aLgYQ\",\"EllipsisDropdown.25cf82d3.js\",\"58UdM\",\"ClassificationEditViewPopup.98c509d9.js\",\"lJxwk\",\"mention.e1e6b40f.js\",\"2BIkk\",\"mention.runtime.35c8860c.js\",\"leIbB\",\"FullPageEditorComponent.c3a54504.js\",\"5zDuS\",\"NativeCollabComponent.2d426b34.js\",\"2F69B\",\"vendors~small-pkgs.a3d4fa09.js\",\"iu10i\",\"NativeCollabComponent.cc3733cd.js\",\"h4Nf7\",\"ExternalUserLozenge.546379e0.js\",\"aHE9G\",\"vendors~editor_atlaskit.588a3242.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.8e54b7e2.js\",\"b91tv\",\"FullPageEditorComponent.11adf162.js\",\"7sZmN\",\"UnarchivePagesLoader.1889041a.js\",\"ktyyJ\",\"TrialFlags.350f78d3.js\",\"dQSCU\",\"OnboardingStateEditor.67abaecb.js\",\"5CTF9\",\"TrialFlags.0b485ead.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.4b18f55f.js\",\"ePA5l\",\"Lozenge.410a9c64.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"eabDm\",\"PremiumLozenge.df9ab2b4.js\",\"fqBFU\",\"ReverseTrialLozenge.857976d2.js\",\"1HAEl\",\"ReverseTrialListItem.f43eeadb.js\",\"koo1l\",\"FullPageEditorComponent.0f41c121.js\",\"7gjV3\",\"FullPageEditorComponent.66a4281f.js\",\"lm5in\",\"FullPageEditorComponent.85993c48.js\",\"1TkAG\",\"IndentIcon.798032fb.js\",\"1ZAFx\",\"FullPageEditorComponent.5d763833.js\",\"gCIfF\",\"FullPageEditorComponent.5a2335e4.js\",\"a9OJ4\",\"FullPageEditorComponent.db271f31.js\",\"aoOM9\",\"FullPageEditorComponent.runtime.fdfcd2d1.js\",\"2ZlZi\",\"FullPageEditorComponent.20109911.js\",\"aLenh\",\"LiveDocSpotlightsTour.8c62f954.js\",\"dY7M5\",\"FullPageEditorComponent.c0d6698a.js\",\"lKccm\",\"FullPageEditorComponent.c6de63ba.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.6fbf9032.js\",\"1GyAj\",\"BreadcrumbsDropdownContent.c736307c.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.be02b2bc.js\",\"aIO5d\",\"BreadcrumbsDropdownContent.cfa19ee7.js\",\"36rXN\",\"MovePageDialog.a4d05c37.js\",\"4PppF\",\"modal.8930cfcf.js\",\"fsZ6i\",\"media-client-react.9e5b66f4.js\",\"7VwsU\",\"media-client-react.runtime.164bfdaf.js\",\"2tDVK\",\"UnarchivePagesLoader.5d46e036.js\",\"gLxW3\",\"UnarchivePagesLoader.da52f784.js\",\"3pIYR\",\"PageSelectionTable.25f062b5.js\",\"dkv9z\",\"PageTreeAfterIcon.043053c5.js\",\"jPS1u\",\"PageTree.a492d72e.js\",\"iBaPm\",\"PageTreeAfterIcon.8d7a0116.js\",\"5w3tp\",\"FullPageEditorComponent.115ac116.js\",\"ebhp1\",\"PageTreeAfterIcon.546d8346.js\",\"9F7vX\",\"CreateContentPopover.df971a79.js\",\"juVlo\",\"ContentTreeOnboarding.41e8f32b.js\",\"6fU2k\",\"drag-handle.629d4432.js\",\"c0kqt\",\"TreeBottomCreateButton.4bbc8344.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.d9e05ac7.js\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"cI7A0\",\"ReadTimePopup.8014e658.js\",\"12qzw\",\"ReadTimePopup.runtime.a28bcafe.js\",\"jrKPL\",\"date.ba75bc92.js\",\"aodrz\",\"FullPageEditorComponent.da608ce2.js\",\"1SiRe\",\"FullPageEditorComponent.131a7aa4.js\",\"dLkMK\",\"FullPageEditorComponent.63f7007f.js\",\"np2ZB\",\"NonMasteredUserModal.9a34fe35.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.fbac545d.js\",\"7p6A4\",\"is-supported.becb4292.js\",\"cvmv4\",\"esm.0856c91d.js\",\"lHceO\",\"cardWithMediaClient.0644b6a1.js\",\"hFfgY\",\"esm.2186c1b5.js\",\"0UPZa\",\"esm.2cbeebd5.js\",\"fKpYd\",\"esm.fdbdb29e.js\",\"12s7O\",\"esm.af4ff8f4.js\",\"6ejFK\",\"modal.95d79c9c.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.2755cdc4.js\",\"kPQBd\",\"CompletionFlag.2360309a.js\",\"lFp1i\",\"FullPageEditorComponent.a82f768e.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.9d67fd2c.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"b5aJh\",\"LoomMigrationModalManager.1b6ff844.js\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"lk8h1\",\"FullPageEditorComponent.68d7bf69.js\",\"16ht2\",\"FullPageEditorComponent.f076efe4.js\",\"hvHZS\",\"TemplatePreview.2b6344f0.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"bupWa\",\"PopupPreview.60eef219.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"2oVPY\",\"ContextualCreateContentPopoverMenu.26983d12.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"9lsAF\",\"ContextualCreateContentPopoverMenu.fad7b7c3.js\",\"4NgYy\",\"ContextualCreateContentPopoverMenu.268dc177.js\",\"jqXtk\",\"FullPageEditorComponent.bece0de4.js\",\"2BIkk\",\"mention.runtime.35c8860c.js\",\"12qzw\",\"ReadTimePopup.runtime.a28bcafe.js\",\"gPhf6\",\"TreeBottomCreateButton.b8a69588.js\",\"dnVDi\",\"top-nav-items.32a4f409.js\",\"iMSgb\",\"top-nav-items.3ff5570b.js\",\"gOjQr\",\"CreateContentPopover.807f8587.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.7e3b4823.js\",\"7QQL7\",\"GlobalCreateContentPopoverMenu.390f2817.js\",\"kiDFE\",\"CreateSpaceMenuItem.708124d3.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.1b2a8415.js\",\"3tVyh\",\"CreateSpacePlusButton.a282b556.js\",\"agpqg\",\"GlobalCreateContentPopoverMenu.e9bfa415.js\",\"clpSH\",\"PageTreeQuickActions.31d98397.js\",\"13PnU\",\"QuickActionsContent.4587ac9e.js\",\"fW5Fh\",\"ReadTime.cb4cd4dd.js\",\"ceWcd\",\"QuickActionsContent.c2e862f0.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.413ebf11.js\",\"bGaMz\",\"RendererContentStateWithSpotlight.534ede87.js\",\"9v84m\",\"PageQuickActionAutomationMenu.43b7959e.js\",\"kCTMZ\",\"PageQuickActionAutomationMenu.8fca6a3e.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"gm70k\",\"QuickActionsContent.d5ed1f34.js\",\"9PeA0\",\"GrantAccessDialog.84f3307c.js\",\"4mWJk\",\"GrantAccessFlag.0374ec79.js\",\"bfhXH\",\"RestrictionsButton.4994d866.js\",\"hzxlF\",\"PageTreeQuickActions.769b2db4.js\",\"PNyg1\",\"InlineRename.1a0d4e9a.js\",\"iPz8n\",\"GlobalFeedbackCollector.3a3b3bce.js\",\"1RolH\",\"EmojiPickerComponent.33aa4312.js\",\"etwBB\",\"activity.2425c769.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.c5cdb0e7.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"6Y8Qe\",\"panel.2a491281.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"6RLxE\",\"MovePageDialog.81935407.js\",\"3L1uC\",\"PageTreeErrorComponent.b558e03e.js\",\"ewwba\",\"PageTreeEmptyComponent.4ec727ea.js\",\"dhqJV\",\"FooterCreateButtons.33a99451.js\",\"67Pvd\",\"ContentTreeOnboarding.2fb5f783.js\",\"d1QkY\",\"TreeBottomCreateButton.c878d03b.js\",\"21dvp\",\"PageTreeEmptyComponent.bafa2ccb.js\",\"dviIw\",\"CollapsibleSection.04be3e46.js\",\"fnoJZ\",\"HomepageIcon.a5e80060.js\",\"6gau7\",\"DraftLozenge.b210c68f.js\",\"5ko8n\",\"MovePageDialog.9687464c.js\",\"f9QHk\",\"TreeMonitor.3caa2a6d.js\",\"deXSb\",\"FullPageEditorComponent.2f409ac4.js\",\"7VwsU\",\"media-client-react.runtime.164bfdaf.js\",\"aoUod\",\"MoveBlogModal.0af62527.js\",\"7WkG0\",\"MoveBlogModal.e55b2d8b.js\",\"cKXbf\",\"BulkChangeOwnerAction.8b0b20b2.js\",\"i3TSs\",\"RestrictionsDialog.518fb51e.js\",\"85liN\",\"InspectPermissionsDialog.da2b9e33.js\",\"iQ0Jm\",\"UnarchivePagesLoader.15382baf.js\",\"14XOE\",\"InspectPermissionsDialog.27088c8e.js\",\"69XGw\",\"InspectPermissionsEntryPoint.39158827.js\",\"9u4sz\",\"MainButtons.56dad465.js\",\"4opMD\",\"ShareRestrictAndCopyCoordinator.72484f68.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.4597d7dd.js\",\"kxRVH\",\"AccessRequestsButton.c0152879.js\",\"hvjHg\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"hFMOd\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"ifr0h\",\"UnarchivePagesLoader.e1bebad3.js\",\"dnZ4C\",\"RestrictionsDialog.cc44bb1a.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"bunf9\",\"Controller.6d4218da.js\",\"7J7Dl\",\"FullPageEditorComponent.4a00f70f.js\",\"1m9tW\",\"FullPageEditorComponent.runtime.35894b53.js\",\"1m9tW\",\"FullPageEditorComponent.runtime.35894b53.js\",\"1sXQt\",\"FavouriteButton.f239394c.js\",\"hWs86\",\"ContentTools.98a4cf03.js\",\"momKe\",\"ExportShareAsPublicLink.355eaf52.js\",\"hRE4a\",\"ContentToolsItemForCopy.47702f5e.js\",\"41vyV\",\"ContentTools.2f04747c.js\",\"kyfJT\",\"ForgeContentTools.0d6f7b2a.js\",\"bzc8Q\",\"ContentToolsItem.73798652.js\",\"2eUdC\",\"EditorContentStateComponent.bf92e660.js\",\"dzXtg\",\"WorkflowStatePageEntry.267c53bc.js\",\"4odwV\",\"WorkflowStatus.69c748b6.js\",\"c2m9M\",\"MainButtons.7b9a8707.js\",\"84iyu\",\"MainButtons.0fd5b2ac.js\",\"fT9RG\",\"LivePagesEllipsisDropdown.ed07a2b3.js\",\"dXoLf\",\"LinkToThisPageDialog.6325537f.js\",\"kmhnK\",\"PageTree.d64d6592.js\",\"3xec3\",\"LivePagesEllipsisDropdown.03031603.js\",\"2nHxT\",\"QRCodeComponent.be5dcb3a.js\",\"289Xl\",\"customCursor.8a87402c.svg\",\"9IaUU\",\"Navigation.2cc4f354.js\",\"62AD8\",\"SettingsMenu.68d6b077.js\",\"3PQqe\",\"ContentTools.50440155.js\",\"dC3sP\",\"ContentTools.407a3570.js\",\"4TY0p\",\"ContentToolsItemWithRoutesContext.0689d78d.js\",\"b03Lm\",\"FullPageEditorComponent.runtime.f1bfd76f.js\",\"i2GTg\",\"FullPageEditorComponent.c633db6e.js\",\"kdcrE\",\"audio-only.61958453.js\",\"cUtrS\",\"WatchDialogWrapper.6d79013e.js\",\"eacuJ\",\"WatchDialog.3a8ca875.js\",\"9OSao\",\"WatchDialogContent.ebc0f7f4.js\",\"awqhH\",\"WatchDialogContent.08e80e22.js\",\"8hbZ5\",\"WatchDialogShortcut.5f5caa2a.js\",\"VoVRZ\",\"WatchDialog.4acb48cb.js\",\"3yFtm\",\"WatchSettingsOverflowMenuShortcut.8a5ae35b.js\",\"iJwzY\",\"ManageWatcherDialog.eb306218.js\",\"ef0fn\",\"KeyboardShortcutsDialog.c12faf93.js\",\"5IuQb\",\"nativeEditorComponentsPreloader.2cb21fba.js\",\"hbc6v\",\"TitleAreaContentComponents.71093a0c.js\",\"dXcJg\",\"FullPageEditorComponent.b5bdd92f.js\",\"4T4bq\",\"PageTree.166e1906.js\",\"gmwfN\",\"ModernizeChangeboarding.ded4e74c.js\",\"iZkNL\",\"Modal.354fc299.js\",\"4jvyy\",\"play-button.f16ed914.png\",\"cmYoQ\",\"thumbnail.4e30c99c.png\",\"7VEEc\",\"whiteboards.5bac062b.svg\",\"1S5Y4\",\"rovo-ai.1a901dc7.svg\",\"dZyP8\",\"reactions-and-stickers.1f3b4ebe.svg\",\"8VWrF\",\"jira-work-items.11443501.svg\",\"55agv\",\"loom-videos.37a4452c.svg\",\"jGjVz\",\"whiteboards-dark.5a9dae19.svg\",\"j77CV\",\"rovo-ai-dark.ac54f515.svg\",\"33gHJ\",\"reactions-and-stickers-dark.fd611bb0.svg\",\"eRF5i\",\"jira-work-items-dark.f74ce1c2.svg\",\"crbaY\",\"loom-videos-dark.1afab585.svg\",\"1uT6p\",\"Modal.ae75147e.js\",\"2FvwL\",\"Modal.ac2007bd.js\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"dTVzs\",\"ObjectSidebarControl.0564abe1.js\",\"dVM1q\",\"EditorPageCoverPictureEntry.2f3c1b6f.js\",\"gGhXk\",\"EditorPageCoverPicture.0ea056cf.js\",\"kIjBt\",\"angle-brackets-icon.e104d1a5.js\",\"6ACCg\",\"chart-bar-icon.1f04b5ae.js\",\"P5iE2\",\"24.18a80ac0.js\",\"42vdC\",\"24.4866b870.js\",\"9Bu2S\",\"24.7e9eed6c.js\",\"8pE8S\",\"24.1dfa6a18.js\",\"ivQYH\",\"24.60e86884.js\",\"7a9CL\",\"24.65a207a0.js\",\"8mzoy\",\"24.5f907e8d.js\",\"bjzRn\",\"24.44a1e682.js\",\"fYi1a\",\"24.985662b4.js\",\"fqrMn\",\"24.60e4661d.js\",\"hzK1f\",\"24.cd837e44.js\",\"eAnbE\",\"cardWithMediaClient.a6798e34.js\",\"ih92g\",\"EditorPageCoverPicture.b2a156e7.js\",\"4hycL\",\"NoResults.9d75157a.svg\",\"k70nv\",\"Carousel.8c6e3912.js\",\"1CVqv\",\"PreviewPageCoverPicture.53fd9a17.js\",\"4Bg7q\",\"RendererPageCoverPicture.c92a7485.js\",\"6jUXq\",\"FullPageEditorComponent.50325255.js\",\"fOegz\",\"EditorPresenceAvatarGroup.57d203b9.js\",\"2cs1O\",\"FullPageEditorComponent.c1852b4b.js\",\"89b92\",\"PublishButtonWithMoreOptions.c1acc79b.js\",\"24IdC\",\"Publish-Modal-Background-Image-Light.4e795a9a.svg\",\"dXonJ\",\"Publish-Modal-Background-Image-Dark.cd843bfb.svg\",\"gZ0i8\",\"PublishHubDialog.8c895718.js\",\"57vSc\",\"PublishButtonWithMoreOptions.3fe31da2.js\",\"anQQJ\",\"PublishModal.6a76c08c.js\",\"iQam7\",\"page.6c3ca97c.svg\",\"jIvk7\",\"whiteboard.d5787185.svg\",\"cuVen\",\"PublishButtonWithMoreOptions.f7a815a2.js\",\"2j9ID\",\"PublishButtonWithMoreOptions.f207c0fa.js\",\"45SdR\",\"modal.b8dab6e7.js\",\"fCqMy\",\"DiscardModal.efc0575f.js\",\"gYiGA\",\"DiscardModal.1bcda449.js\",\"a6uKK\",\"CancelSchedulePublishModal.22ddf37d.js\",\"h2HOI\",\"PublishModalMountPoint.d978a561.js\",\"kXcA7\",\"PublishModalKeyboardShortcuts.5ea4320f.js\",\"4p9Qk\",\"FullPageEditorComponent.c62d349d.js\",\"3YiKe\",\"ContentHeaderPresence.085ff5ad.js\",\"2GoC2\",\"presence-spotlight-img.518d169f.png\",\"aGQ89\",\"telepointer-spotlight-img.686800d4.png\",\"lViCt\",\"NativeCollabComponent.2584604e.js\",\"eGpWr\",\"OnboardingStateEditor.7edbaf22.js\",\"1F4Et\",\"NativeCollabComponent.b8880502.js\",\"bVl1P\",\"CustomHeaderFooter.c30f5597.js\",\"cGAab\",\"InlineCommentsHighlighter.9df7b100.js\",\"cFYwo\",\"ContentTypesHeader.7fcfa3d9.js\",\"dkj9b\",\"ContentTypesHeader.8562ee22.js\",\"esMxL\",\"MainButtons.321fb2d1.js\",\"jYr96\",\"DraftStatus.1487bf82.js\",\"iWKl1\",\"ScheduledStatus.5b45a5ff.js\",\"aoOM9\",\"FullPageEditorComponent.runtime.fdfcd2d1.js\",\"42PSc\",\"AutomationPremiumTip.391e39d4.js\",\"ewSSf\",\"PremiumTrialOnboardingModal.1273683f.js\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"ikem6\",\"DevToolsDialog.ab440927.js\"]"));


//# sourceMappingURL=ShareButton.2e163b02.js.map
